import React from 'react'
import { TimeOffRequestDetails, isVacationBid } from '../../../../store/slices/Requestor/timeOffDetailsSlice'
import RightPanel from './RightPanel'
import CurrentRequestSection from './CurrentRequestSection'
import HistorySection from './HistorySection'
import { normalizeStatus } from './constants'
import RetractionDetailFields from './RetractionDetailFields'
import { getVacationBidAwareTableProps } from './vacationBidOverlapDisplay'

interface PartialRetractedViewProps {
  data: TimeOffRequestDetails
  tableRows: any[]
  highlightedDates: string[]
  handlePrint?: () => void
}

const PartialRetractedView: React.FC<PartialRetractedViewProps> = ({
  data,
  tableRows,
  highlightedDates,
  handlePrint,
}) => {
  const isAdminMode = globalThis.location.pathname.startsWith('/admin')
  const ns = normalizeStatus(data.status)
  const heading = ns === 'pretracted' ? 'Time Off Request Partially Retraction Approved' : 'Time Off Request Partial Retraction Denied'
  const showSubmissionDetails = ns === 'prtdenied'
  return (
    <div>
    <h1 className="h1">{heading}</h1>

    <div className="flex flex-col mobile:gap-4 tablet:gap-6 desktop:gap-8 desktop:flex-row">
      <div className="flex-1">
        <RetractionDetailFields
          data={data}
          isAdminMode={isAdminMode}
          showDenialReason={true}
        />
      </div>

      <RightPanel
        data={data}
        variant="name-id"
        showSubmissionDetails={showSubmissionDetails}
        handlePrint={handlePrint}
      />
    </div>

    <div className="mt-6!">
      <hr className="-variation-1" />
    </div>

    {data.history && data.history.length > 0 && (
      <HistorySection history={data.history} />
    )}

    <CurrentRequestSection
      {...getVacationBidAwareTableProps(tableRows, isVacationBid(data))}
      highlightedDates={highlightedDates}
    />
  </div>
)
}

export default PartialRetractedView